<template>
  <div>
    <el-card shadow="never"
             class="aui-card--fill">
      <el-form :model="dataForm"
               ref="dataForm">
        <div class="location-layout">
          <el-row :gutter="0" class="mb-20">
            <!-- 课程编号 -->
            <el-col :span="6">
              <el-form-item>
                <div class="link-type"
                     @click="courClick">{{ $t('res.courseclassroomrela.courseNo')}}</div>
                  <el-input v-model="dataForm.courseNo"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.selectFromLeft')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程状态 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.coursesSatus')"
                            prop="status">
                  <el-input v-model="dataForm.status"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.coursesSatus')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程名称 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseName')"
                            prop="coursecName">
                  <el-input v-model="dataForm.coursecName"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseName')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程时间 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseTime')"
                            prop="courseTime">
                  <el-input v-model="dataForm.courseTime"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseTime')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0" class="mb-20">
            <!-- 最大人数 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.maxPersonNo')"
                            prop="maxPersonNo">
                  <el-input v-model="dataForm.maxPersonNo"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.maxPersonNo')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 最小人数 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.miniPersonNo')"
                            prop="miniPersonNo">
                  <el-input v-model="dataForm.miniPersonNo"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.miniPersonNo')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 课程分类 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseClassId')"
                            prop="courseClass">
                  <el-input v-model="dataForm.courseClass"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseClassId')">
                </el-input>
              </el-form-item>
            </el-col>
            <!-- 团队分类 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.courseTeamClassification')"
                            prop="teamClass">
                  <el-input v-model="dataForm.teamClass"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.courseTeamClassification')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="0">
            <!-- 上课所需教室数量 -->
            <el-col :span="6">
              <el-form-item :label="$t('res.courseclassroomrela.classroomCount')"
                            prop="classroomCount">
                  <el-input v-model="dataForm.classroomCount"
                      :disabled="true"
                      :placeholder="$t('res.courseclassroomrela.bySystem')">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
      <div style="overflow-x: hidden">
        <div style="line-height: 20px; margin-top:20px">{{ $t('res.courseclassroomrela.classroompoolExplain1') }}</div>
        <div style="line-height: 20px; margin-left:43px">{{ $t('res.courseclassroomrela.classroompoolExplain2') }}</div>
        <div style="line-height: 20px; margin-bottom:20px; margin-left:43px ">{{ $t('res.courseclassroomrela.classroompoolExplain3') }}</div>
        <template v-for="(item, index) in classroomList">
          <el-row :key="'pool' + index"
                  style="margin-bottom: 10px;">
            <el-col :span="24"
                    style=" text-align:left;">
              <!-- 教室池教室选择 -->
              <div><span class="link-type"
                   @click="handleNodeClick(classroomList[index].classroomPoolListObj,index)">{{ $t('res.courseclassroomrela.classroompool')}}{{index + 1}}</span></div>
            </el-col>
          </el-row>
          <el-row :key="'remark' + index"
                  style="margin-bottom: 10px; line-height: 34px;">
            <el-col :span="1"
                    style="min-width: 70px;">
              <div style="line-height: 34px">{{ $t('res.courseclassroomrela.remark') }}</div>
            </el-col>
            <el-col :span="20">
              <el-input style="display: inline-block;"
                        v-model="classroomList[index].remarks"
                        :placeholder="$t('cert.inputTips')"
                        :maxlength="200">
              </el-input>
            </el-col>
            <el-col :span="2">
              <div class="show-or-hide-icon"
                  v-bind:class="{ 'el-icon-arrow-up': classroomList[index].poolview,
                                          'el-icon-arrow-down': !classroomList[index].poolview }"
                  @click="classroomList[index].poolview = !classroomList[index].poolview">&nbsp;{{ classroomList[index].poolview ? $t('common.hide') : $t('res.courseclassroomrela.open') }}
              </div>
            </el-col>
          </el-row>
          <el-row :key="index">
            <el-col :span="24">
              <el-table :data="classroomList[index].classroomPoolListObj"
                        border v-show="classroomList[index].poolview"
                        style="width: 100%;">
                <!-- NO -->
                <el-table-column prop="courseNo"
                                  header-align="center"
                                  type="index"
                                  align="center"
                                  :label="$t('res.courseclassroomrela.label')">
                </el-table-column>
                <!-- 教室ID -->
                <el-table-column prop="classroomId"
                                  header-align="center"
                                  align="center"
                                  v-if="false"
                                  width="100"
                                  :label="$t('handle')">
                </el-table-column>
                <!-- 教室编号 -->
                <el-table-column prop="classroomNo"
                                  header-align="center"
                                  align="center"
                                  width="100"
                                  show-overflow-tooltip
                                  :label="$t('res.courseclassroomrela.classroomNo')">
                </el-table-column>
                <!-- 教室名称 -->
                <el-table-column prop="roomCnName"
                                  header-align="center"
                                  align="center"
                                  show-overflow-tooltip
                                  :label="$t('res.courseclassroomrela.roomCnName')">
                </el-table-column>
                <!-- 教室分类 -->
                <el-table-column prop="classroomClass"
                                  header-align="center"
                                  align="center"
                                  show-overflow-tooltip
                                  :label="$t('res.courseclassroomrela.classroomClass')">
                </el-table-column>
                <!-- 所属场地 -->
                <el-table-column prop="site"
                                  header-align="center"
                                  align="center"
                                  show-overflow-tooltip
                                  :label="$t('res.courseclassroomrela.siteName')">
                </el-table-column>
                <!-- 教室状态 -->
                <el-table-column prop="status"
                                  :formatter="statusFormatter"
                                  header-align="center"
                                  align="center"
                                  show-overflow-tooltip
                                  :label="$t('res.courseclassroomrela.status')">
                </el-table-column>
                <!-- 教室标签 -->
                <el-table-column prop="classroomLabel"
                                  header-align="center"
                                  align="center"
                                  :label="$t('res.courseclassroomrela.classroomLabel')">
                  <template slot-scope="scope">
                    <span class="el-dropdown-link"
                          v-if="scope.row.numberLaber !== null"
                          @click="checkLable(scope.row)">{{ $t('view') }}</span>
                  </template>
                </el-table-column>
                <!-- 优先级 -->
                <el-table-column prop="priority"
                                  header-align="center"
                                  align="center"
                                  :label="$t('res.courseclassroomrela.priority')">
                  <template slot-scope="scope">
                    <div style="line-height: 34px;">
                      <el-select style="width: 80px!important;display: inline-block;"
                                  v-model="scope.row.priority">
                        <el-option v-for="(item,index) in priorityArr"
                                    :key="index"
                                    :label="item.name"
                                    :value="item.code">
                        </el-option>
                      </el-select>
                    </div>
                  </template>
                </el-table-column>
                <!-- 操作 -->
                <el-table-column fixed="right"
                                  align="center"
                                  :width="100"
                                  :label="$t('handle')">
                  <template slot-scope="scope">
                    <el-button type="text" size="medium" @click="deleteClassroom(index, scope.$index)">{{ $t('delete') }}</el-button>
                  </template>
                </el-table-column>
              </el-table>
              <el-row style="border-bottom: 1px solid #b4bccc; margin-bottom: 20px;"></el-row>
              <el-row class="btn-position-up"
                      style="text-align:right; margin-bottom: 10px;">
                <el-button type="primary"
                            v-show="index !== 0"
                            @click="deletePool(index)">{{ $t('res.courseclassroomrela.remove') }}</el-button>
              </el-row>
            </el-col>
          </el-row>
        </template>
        <!-- 新增按钮 -->
        <el-row class="btn-position-up">
          <el-button type="primary"
                     @click="insertPool()">{{ $t('add') }}</el-button>
        </el-row>
      </div>
      <!-- 按钮区域 -->
      <div class="btn-position-up"
           style="text-align:right;">
        <!-- 保存按钮 -->
        <el-button type="primary"
                   @click="dataFormSubmitHandle()">{{ $t('res.courseclassroomrela.save') }}</el-button>
        <!-- 关闭按钮 -->
        <ZElButton @click="backPage()">{{ $t('res.courseclassroomrela.close') }}</ZElButton>
      </div>
    </el-card>
    <!-- 课程选择页面 -->
    <el-dialog :title="$t('res.courseclassroomrela.alternativeCourse')"
               :visible="isShowcour"
               width="95%"
               :before-close="courClose">
      <cour-element v-on:couronOk="couronOk" v-bind:url="courseSelectUrl" v-bind:teamPerms="teamPerms" ref="courseSelectRef"></cour-element>
    </el-dialog>
    <!-- 教室选择页面 -->
    <el-dialog :title="$t('res.courseclassroomrela.alternativeClassroom')"
               :visible="isShowclassroom"
               width="95%"
               :before-close="handleClose">
      <classroom-element ref="classroomInfoRef"
                    v-on:onOk="onOk"
                    v-bind:classroomInfoList="classroomInfoList"></classroom-element>
    </el-dialog>
    <!-- 标签查看 -->
    <el-dialog title="标签查看"
                :visible="isShowLable"
                width="70%"
                :before-close="showLableClose">
      <el-form label-position="top"
                label-width="150px"
                :ref="dataForm">
        <div>
          <el-row>
            <el-col :span="24">
              <el-form-item prop="tagName"
                            style="width: 100%!important;">
                <tag :checkedList="showcheckList"
                      :moduleId="moduleId"
                      :overLabelShow = "false"
                      :closeShow = "false"
                      :bussinessTypeId = "bussinessTypeId"
                      :brandCode="bussinessTypeChecked"
                      @getBussinessType="getBussinessType"
                      @changeCheckedList="changeShowCheckedList"
                      ref='tagTree'
                      @fatherMethod="fatherMethod"></tag>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// import CourItem from '@/components/rm/course-choice/index'
import ClassroomItem from '@/components/rm/classroom-choice/index'
// import courseChoiceRela from '../learning/common/courseChoiceRela'
import courseChoiceRela from '@/components/rm/course-rela-single/index'
import ZElButton from '@/components/rm/button/index'
import Tag from '@/components/rm/label-select/index'
import VueI18n from '@/i18n'
import Vue from 'vue'
export default {
  components: {
    Tag,
    // 'cour-element': CourItem,
    'cour-element': courseChoiceRela,
    'classroom-element': ClassroomItem,
    ZElButton
  },
  data () {
    return {
      onload: '',
      visible: false,
      isShowcour: false,
      isShowclassroom: false,
      classroomList: [{ 'remarks': '', 'poolview': true, 'classroomPoolListObj': [] }],
      classroomInfoList: [],
      classroomInfoList1: [],
      classroomInfoObj: {},
      dataListLoading: false,
      priorityArr: this.enums['priority'], // 优先级
      // 选择工位教室池弹出教室选择框，确认时赋值
      courseClassroomindex: '',
      courseSelectUrl: '/rm/courseclassroomrela/coursequery',
      dataForm: {
        courseClassroomRelaId: 0,
        courseId: '',
        courseNo: '',
        status: '',
        coursecName: '',
        courseTime: '',
        maxPersonNo: '',
        miniPersonNo: '',
        courseClass: '',
        teamClass: '',
        classroomCount: '1'
      },
      isShowLable: false,
      checkList: [],
      showcheckList: [],
      // 模块id，20 代表组织管理模块
      moduleId: '20',
      bussinessTypeId: 10,
      bussinessTypeChecked: 10,
      teamPerms: 'CLASSROOMTEAM'
    }
  },
  activated () {
    this.$eventHub.$on('classroomAdd', (data) => {
      if (this.$refs['dataForm'] !== undefined) {
        this.$refs['dataForm'].resetFields()
        this.dataForm.courseNo = ''
      }
      this.classroomList = [{ 'remarks': '', 'poolview': true, 'classroomPoolListObj': [] }]
      this.$request.get(`/rm/courseclassroomrela/queryBussinessTypeIdRela`).then((res, total, code, data) => {
        if (data.data != null && data.data != undefined) {
          this.bussinessTypeId = data.data
          this.bussinessTypeChecked = data.data
        }
      })
    })
  },
  methods: {
    insertPool () {
      this.classroomList.push({ 'remarks': '', 'poolview': true, 'classroomPoolListObj': [] })
      this.dataForm.classroomCount = this.classroomList.length
    },
    deletePool (index) {
      this.$confirm(this.$t('prompt.info', { 'handle': this.$t('delete') }), this.$t('prompt.title'), {
        confirmButtonText: this.$t('confirm'),
        cancelButtonText: this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        this.classroomList.splice(index, 1)
        this.dataForm.classroomCount = this.classroomList.length
      })
    },
    deleteClassroom (parentIndex, childrenIndex) {
      this.classroomList[parentIndex].classroomPoolListObj.splice(childrenIndex, 1)
    },
    // 状态转换
    statusFormatter (row) {
      return Vue.filter('coverEnum')(row.status, 'status')
    },
    // 课程选择弹出页面事件
    courClick () {
      this.isShowcour = true
      this.$nextTick(() => {
        this.$refs.courseSelectRef.init()
      })
    },
    // 课程选择关闭页面事件
    courClose () {
      this.isShowcour = false
    },
    couronOk (select) {
      let _this = this
      _this.dataForm.courseId = select.courseId
      _this.dataForm.courseNo = select.courseNo
      _this.dataForm.status = select.status
      _this.dataForm.coursecName = select.coursecName
      _this.dataForm.courseTime = select.courseTime
      _this.dataForm.maxPersonNo = select.maxPersonNo
      _this.dataForm.miniPersonNo = select.miniPersonNo
      // _this.dataForm.courseClass = select.classcName1 + ',' + select.classcName2 + ',' + select.classcName3
      _this.dataForm.courseClass = select.courseClass
      _this.dataForm.teamClass = select.teamName
      this.isShowcour = false
    },
    // 教室选择弹出页面事件
    handleNodeClick (classroomInfoList, index) {
      this.classroomInfoList = classroomInfoList
      this.poolIndex = index
      this.courseClassroomindex = index
      this.isShowclassroom = true
      // 调用教室弹框的初始化方法
      this.$nextTick(() => {
        this.$refs.classroomInfoRef && this.$refs.classroomInfoRef.initMethods()
      })
    },
    // 车辆选择关闭页面事件
    handleClose () {
      this.isShowclassroom = false
    },
    // 教室弹出页面赋值给主页面
    onOk (selectList) {
      let _this = this
      let hasflg = false
      // _this.classroomList[_this.poolIndex].classroomPoolListObj = []
      selectList.forEach(function (item) {
        _this.classroomInfoList.forEach(function (preItem) {
          if (item.classroomId === preItem.classroomId) {
            hasflg = true
          }
        })
        if (!hasflg) {
          _this.classroomInfoObj = {}
          _this.classroomInfoObj.classroomId = item.classroomId
          _this.classroomInfoObj.classroomNo = item.classroomNo
          _this.classroomInfoObj.roomCnName = item.classroomName
          _this.classroomInfoObj.classroomClass = item.classroomClass
          _this.classroomInfoObj.site = item.classification
          _this.classroomInfoObj.status = item.classStatus
          _this.classroomInfoObj.classroomLabel = item.classroomTag
          _this.classroomInfoObj.priority = item.priority
          _this.classroomInfoObj.numberLaber = item.numberLaber
          _this.classroomList[_this.poolIndex].classroomPoolListObj.push(JSON.parse(JSON.stringify(_this.classroomInfoObj)))
        }
        hasflg = false
      })
      _this.dataForm.classroomCount = _this.classroomList.length
      this.isShowclassroom = false
    },
    // 表单提交
    dataFormSubmitHandle () {
      let _this = this
      let ifag = false
      let selectIndex = 0
      // 控制保存按钮，防止重复点击保存
      _this.dataListLoading = true
      if (_this.dataForm.courseNo === null || _this.dataForm.courseNo === '') {
        // 控制保存按钮，防止重复点击保存
        _this.dataListLoading = false
        _this.$message.warning(_this.$t('res.courseclassroomrela.course'))
        return false
      } else {
        _this.classroomList.forEach(function (item, index) {
          if (item.classroomPoolListObj.length === 0) {
            ifag = true
            if (selectIndex === 0) {
              selectIndex = index + 1
            }
          }
        })
      }
      if (ifag) {
        _this.$message.warning(_this.$t('res.courseclassroomrela.classroompoolSelect') + selectIndex + _this.$t('res.courseclassroomrela.classroomSelect'))
        // 控制保存按钮，防止重复点击保存
        _this.dataListLoading = false
        return false
      }
      // 触发校验
      _this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          let url = ''
          let param = ''
          url = '/rm/courseclassroomrela/save'
          param = {
            courseId: _this.dataForm.courseId,
            courseClassroomRelaListObj: _this.classroomList
          }
          _this.$request.post(
            url, param
          ).then((data) => {
            _this.$message({
              message: _this.$t('prompt.success'),
              type: 'success',
              duration: 500,
              onClose: () => {
                _this.dataListLoading = false
                _this.dataForm = ''
                _this.classroomList = [{ 'remarks': '', 'classroomPoolListObj': [] }]
                // _this.$router.go(-1)
                _this.tabRemove()
              }
            })
          })
        }
      })
    },
    backPage () {
      // this.$router.go(-1)
      let _this = this
      _this.$confirm(_this.$t('res.courseclassroomrela.cancelinfo'), _this.$t('prompt.title'), {
        confirmButtonText: _this.$t('confirm'),
        cancelButtonText: _this.$t('cancel'),
        type: 'warning'
      }).then(() => {
        _this.tabRemove()
      })
    },
    // 删除当前页面
    tabRemove () {
      let tabName = this.$store.state.contentTabsActiveName
      if (tabName === 'home') {
        return false
      }
      this.$store.state.contentTabs = this.$store.state.contentTabs.filter(item => item.name !== tabName)
      if (this.$store.state.contentTabs.length <= 0) {
        this.$store.state.sidebarMenuActiveName = this.$store.state.contentTabsActiveName = 'home'
        return false
      }
      // 当前选中tab被删除
      if (tabName === this.$store.state.contentTabsActiveName) {
        this.$router.push({ name: this.$store.state.contentTabs[this.$store.state.contentTabs.length - 1].name })
      }
    },
    checkLable(row){
      this.isShowLable = true
      this.$request.get(`/rm/courseclassroomrela/queryCheckedCommLabel/${row.classroomId}/${this.bussinessTypeId}`).then((data) => {
        // 已选择的标签
        this.showcheckList = data ? data : []
        // 特殊情况，自己国际化
        const language = VueI18n.locale
        if (language === 'zh-CN') {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameCn
          })
        } else {
          this.showcheckList.forEach(o => {
            o.labelName = o.labelNameEn
          })
        }
      })
    },
    showLableClose(){
      this.showcheckList = []
      this.isShowLable = false
    },
    getBussinessType (val) {
      this.bussinessTypeId = val
    },
    changeShowCheckedList (array) {
      this.showcheckList = array
    },
    // 重新勾选业务标签
    fatherMethod () {
      // this.checkList = []
      // 已选择的标签
      // this.checkList = this.dataForm.commLabelVoList ? this.dataForm.commLabelVoList : []
      // 特殊情况，自己国际化
      const language = VueI18n.locale
      if (language === 'zh-CN') {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameCn
        })
      } else {
        this.checkList.forEach(o => {
          o.labelName = o.labelNameEn
        })
      }
    }
  }
}
</script>
<style scoped>
.mb-20{
  margin-bottom: 20px;
}
.link-type,
.link-type:focus {
  color: #337ab7;
  cursor: pointer;
}
.link-type:hover {
  color: rgb(32, 160, 255);
}
</style>
